// import React, { useEffect, useState } from "react";
// import { useForm } from "react-hook-form";
// import { Label } from "../components/ui/label";
// import {
//   Form,
//   FormControl,
//   FormField,
//   FormItem,
//   FormLabel,
//   FormMessage,
// } from "../components/ui/form";
// import { Input } from "../components/ui/input";
// import { Button } from "../components/ui/button";
// import { zodResolver } from "@hookform/resolvers/zod";
// import {
//   Command,
//   CommandEmpty,
//   CommandGroup,
//   CommandInput,
//   CommandItem,
// } from "../components/ui/command";
// import { z } from "zod";
// import { useToast } from "../components/ui/use-toast";
// import { ClipLoader } from "react-spinners";
// import { cn } from "../lib/utils";
// import {
//   Popover,
//   PopoverContent,
//   PopoverTrigger,
// } from "../components/ui/popover";
// import { Check, ChevronsUpDown } from "lucide-react";
// import {
//   useInviteTradingPartner,
//   useGetAllPermissions,
// } from "../migration-api/api-hooks/trading-partners";
// import { useCheckClientLocations } from "../migration-api/api-hooks/clients";
// import { ScrollArea } from "../components/ui/scroll-area";
// import { Checkbox } from "../components/ui/checkbox";

// const InviteTradingPartner = ({ client, onSuccess }) => {
//   const { toast } = useToast();
//   const [clientLocations, setClientLocations] = useState([]);
//   const [selectedPermissions, setSelectedPermissions] = useState([]);

//   const formSchema = z.object({
//     email: z.string().trim().email({
//       message: "Only valid email is allowed",
//     }),
//     firstName: z.string().trim().min(1, {
//       message: "First name is required",
//     }),
//     lastName: z.string().trim().min(1, {
//       message: "Last name is required",
//     }),
//     location: z
//     .string()
//     .trim()
//     .min(1, { message: "Enter the location GLN" })
//     .regex(/^\d+$/, {
//       message: "Location must contain only numbers",
//     }),
//     permissions: z.array(z.string()).min(1, {
//       message: "Please select at least one permission",
//     }),
//   });

//   const form = useForm({
//     resolver: zodResolver(formSchema),
//     defaultValues: {
//       email: "",
//       firstName: "",
//       lastName: "",
//       location: "",
//       permissions: [],
//     },
//   });

//   // Fetch all available permissions
//   const { data: permissionsResponse, isLoading: isLoadingPermissions } =
//     useGetAllPermissions();

//   const permissions = permissionsResponse?.data || [];

//   // Mutation for inviting trading partner
//   const { mutate: inviteTradingPartner, isLoading } = useInviteTradingPartner({
//     onSuccess: (data) => {
//       toast({
//         variant: "success",
//         title: "Success",
//         description: data.message || "Trading partner invited successfully",
//       });
//       // Reset form
//       form.reset();
//       setSelectedPermissions([]);
//       if (onSuccess) onSuccess();
//     },
//     onError: (error) => {
//       toast({
//         variant: "destructive",
//         title: "Error",
//         description:
//           error?.response?.data?.message || "Failed to invite trading partner",
//       });
//     },
//   });

//   const handlePermissionToggle = (permissionName) => {
//     setSelectedPermissions((prev) => {
//       const isSelected = prev.includes(permissionName);
//       const newPermissions = isSelected
//         ? prev.filter((p) => p !== permissionName)
//         : [...prev, permissionName];

//       // Update form value
//       form.setValue("permissions", newPermissions);
//       return newPermissions;
//     });
//   };

//   function onSubmit(data) {
//     const payload = {
//       email: data.email,
//       clientId: client.id,
//       firstName: data.firstName,
//       lastName: data.lastName,
//       location: data.location,
//       permissions: data.permissions,
//     };

//     inviteTradingPartner(payload);
//   }

//   return (
//     <div className="h-screen">
//       <ScrollArea className="h-[800px] w-full px-4">
//         <div className="pb-14">
//           <Form {...form}>
//             <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-8">
//               <FormField
//                 control={form.control}
//                 name="firstName"
//                 render={({ field }) => (
//                   <FormItem>
//                     <Label>First Name</Label>
//                     <FormControl>
//                       <Input
//                         type="text"
//                         placeholder="John"
//                         autoComplete="off"
//                         {...field}
//                       />
//                     </FormControl>
//                     <FormMessage />
//                   </FormItem>
//                 )}
//               />

//               <FormField
//                 control={form.control}
//                 name="lastName"
//                 render={({ field }) => (
//                   <FormItem>
//                     <Label>Last Name</Label>
//                     <FormControl>
//                       <Input
//                         type="text"
//                         placeholder="Doe"
//                         autoComplete="off"
//                         {...field}
//                       />
//                     </FormControl>
//                     <FormMessage />
//                   </FormItem>
//                 )}
//               />

//               <FormField
//                 control={form.control}
//                 name="email"
//                 render={({ field }) => (
//                   <FormItem>
//                     <Label>Email Address</Label>
//                     <FormControl>
//                       <Input
//                         type="email"
//                         placeholder="partner@example.com"
//                         autoComplete="off"
//                         {...field}
//                       />
//                     </FormControl>
//                     <FormMessage />
//                   </FormItem>
//                 )}
//               />

//               {/* Location */}
//               <FormField
//                 control={form.control}
//                 name="location"
//                 render={({ field }) => (
//                   <FormItem className="flex flex-col">
//                     <FormLabel>Location</FormLabel>
//                     <Popover>
//                       <PopoverTrigger asChild>
//                         <FormControl>
//                           <Input
//                             type="text"
//                             placeholder="6128343120001"
//                             autoComplete="off"
//                             {...field}
//                           />
//                         </FormControl>
//                       </PopoverTrigger>
//                     </Popover>
//                     <FormMessage />
//                   </FormItem>
//                 )}
//               />

//               {/* Permissions Selection */}
//               <FormField
//                 control={form.control}
//                 name="permissions"
//                 render={({ field }) => (
//                   <FormItem className="flex flex-col">
//                     <FormLabel>Permissions</FormLabel>
//                     {isLoadingPermissions ? (
//                       <div className="flex items-center justify-center py-4 border rounded-md">
//                         <ClipLoader size={20} />
//                       </div>
//                     ) : permissions.length === 0 ? (
//                       <div className="text-sm text-gray-500 py-4 border rounded-md text-center">
//                         No permissions available
//                       </div>
//                     ) : (
//                       <>
//                         <ScrollArea className="h-[200px] border rounded-md p-3">
//                           <div className="space-y-3">
//                             {permissions.map((permission) => {
//                               const permissionName =
//                                 permission.name || permission;
//                               const permissionDisplay =
//                                 permission.displayName ||
//                                 permission.name ||
//                                 permission;

//                               return (
//                                 <div
//                                   key={permission.id || permissionName}
//                                   className="flex items-center space-x-2"
//                                 >
//                                   <Checkbox
//                                     id={`permission-${permission.id || permissionName}`}
//                                     checked={selectedPermissions.includes(
//                                       permissionName,
//                                     )}
//                                     onCheckedChange={() =>
//                                       handlePermissionToggle(permissionName)
//                                     }
//                                   />
//                                   <label
//                                     htmlFor={`permission-${permission.id || permissionName}`}
//                                     className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
//                                   >
//                                     {permissionDisplay}
//                                   </label>
//                                 </div>
//                               );
//                             })}
//                           </div>
//                         </ScrollArea>
//                         <p className="text-xs text-muted-foreground">
//                           Selected: {selectedPermissions.length} permission(s)
//                         </p>
//                       </>
//                     )}
//                     <FormMessage />
//                   </FormItem>
//                 )}
//               />

//               <Button type="submit" disabled={isLoading}>
//                 {isLoading ? (
//                   <span className="mx-[20px]">
//                     <ClipLoader color="white" size={20} />
//                   </span>
//                 ) : (
//                   <span>Submit</span>
//                 )}
//               </Button>
//             </form>
//           </Form>
//         </div>
//       </ScrollArea>
//     </div>
//   );
// };

// export default InviteTradingPartner;




import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Label } from "../components/ui/label";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../components/ui/form";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { useToast } from "../components/ui/use-toast";
import { ClipLoader } from "react-spinners";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../components/ui/popover";
import {
  useInviteTradingPartner,
  useGetAllPermissions,
} from "../migration-api/api-hooks/trading-partners";
import { ScrollArea } from "../components/ui/scroll-area";
import { Checkbox } from "../components/ui/checkbox";
import { PERMISSION_GROUPS } from "../utils/permissionGroups";


// Prettify "CREATE_COMMISSION" → "Create Commission"
const formatPermissionLabel = (key) =>
  key
    .split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");

// ─── Permission Group Row ─────────────────────────────────────────────────────
const PermissionGroup = ({ group, availablePermissions, selectedPermissions, onToggle, onToggleAll }) => {
  // Only show permissions that actually exist in the API response
  const groupPermissions = group.permissions.filter((p) =>
    availablePermissions.includes(p),
  );

  if (groupPermissions.length === 0) return null;

  const allSelected = groupPermissions.every((p) => selectedPermissions.includes(p));
  const someSelected = groupPermissions.some((p) => selectedPermissions.includes(p));

  return (
    <div className="space-y-2">
      {/* Group header with select-all */}
      <div className="flex items-center justify-between py-1 border-b">
        <div className="flex items-center space-x-2">
          <Checkbox
            id={`group-${group.label}`}
            checked={allSelected}
            // indeterminate visual via data attribute when partially selected
            data-state={allSelected ? "checked" : someSelected ? "indeterminate" : "unchecked"}
            onCheckedChange={() => onToggleAll(groupPermissions, allSelected)}
          />
          <label
            htmlFor={`group-${group.label}`}
            className="text-xs font-semibold uppercase tracking-wide text-muted-foreground cursor-pointer select-none"
          >
            {group.label}
          </label>
        </div>
        <span className="text-xs text-muted-foreground">
          {groupPermissions.filter((p) => selectedPermissions.includes(p)).length}/
          {groupPermissions.length}
        </span>
      </div>

      {/* Individual permissions in a 2-col grid */}
      <div className="grid grid-cols-2 gap-x-4 gap-y-2 pl-1">
        {groupPermissions.map((permission) => (
          <div key={permission} className="flex items-center space-x-2">
            <Checkbox
              id={`permission-${permission}`}
              checked={selectedPermissions.includes(permission)}
              onCheckedChange={() => onToggle(permission)}
            />
            <label
              htmlFor={`permission-${permission}`}
              className="text-sm leading-none cursor-pointer select-none"
            >
              {formatPermissionLabel(permission)}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

// ─── Main Component ───────────────────────────────────────────────────────────
const InviteTradingPartner = ({ client, onSuccess }) => {
  const { toast } = useToast();
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  const formSchema = z.object({
    email: z.string().trim().email({ message: "Only valid email is allowed" }),
    firstName: z.string().trim().min(1, { message: "First name is required" }),
    lastName: z.string().trim().min(1, { message: "Last name is required" }),
    location: z
      .string()
      .trim()
      .min(1, { message: "Enter the location GLN" })
      .regex(/^\d+$/, { message: "Location must contain only numbers" }),
    permissions: z.array(z.string()).min(1, {
      message: "Please select at least one permission",
    }),
  });

  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      email: "",
      firstName: "",
      lastName: "",
      location: "",
      permissions: [],
    },
  });

  const { data: permissionsResponse, isLoading: isLoadingPermissions } =
    useGetAllPermissions();

  // Normalize API permissions to a flat array of strings
  const availablePermissions = (permissionsResponse?.data || []).map(
    (p) => p.name || p,
  );

  const { mutate: inviteTradingPartner, isLoading } = useInviteTradingPartner({
    onSuccess: (data) => {
      toast({
        variant: "success",
        title: "Success",
        description: data.message || "Trading partner invited successfully",
      });
      form.reset();
      setSelectedPermissions([]);
      if (onSuccess) onSuccess();
    },
    onError: (error) => {
      toast({
        variant: "destructive",
        title: "Error",
        description:
          error?.response?.data?.message || "Failed to invite trading partner",
      });
    },
  });

  // Toggle a single permission
  const handlePermissionToggle = (permissionName) => {
    setSelectedPermissions((prev) => {
      const next = prev.includes(permissionName)
        ? prev.filter((p) => p !== permissionName)
        : [...prev, permissionName];
      form.setValue("permissions", next, { shouldValidate: true });
      return next;
    });
  };

  // Toggle all permissions in a group
  const handleToggleAll = (groupPermissions, allSelected) => {
    setSelectedPermissions((prev) => {
      const next = allSelected
        ? prev.filter((p) => !groupPermissions.includes(p))  // deselect all
        : [...new Set([...prev, ...groupPermissions])];       // select all
      form.setValue("permissions", next, { shouldValidate: true });
      return next;
    });
  };

  function onSubmit(data) {
    inviteTradingPartner({
      email: data.email,
      clientId: client.id,
      firstName: data.firstName,
      lastName: data.lastName,
      location: data.location,
      permissions: data.permissions,
    });
  }

  return (
    <div className="h-screen">
      <ScrollArea className="h-[800px] w-full px-4">
        <div className="pb-14">
          <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">

              {/* First Name */}
              <FormField
                control={form.control}
                name="firstName"
                render={({ field }) => (
                  <FormItem>
                    <Label>First Name</Label>
                    <FormControl>
                      <Input type="text" placeholder="John" autoComplete="off" {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />

              {/* Last Name */}
              <FormField
                control={form.control}
                name="lastName"
                render={({ field }) => (
                  <FormItem>
                    <Label>Last Name</Label>
                    <FormControl>
                      <Input type="text" placeholder="Doe" autoComplete="off" {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />

              {/* Email */}
              <FormField
                control={form.control}
                name="email"
                render={({ field }) => (
                  <FormItem>
                    <Label>Email Address</Label>
                    <FormControl>
                      <Input type="email" placeholder="partner@example.com" autoComplete="off" {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />

              {/* Location */}
              <FormField
                control={form.control}
                name="location"
                render={({ field }) => (
                  <FormItem className="flex flex-col">
                    <FormLabel>Location</FormLabel>
                    <FormControl>
                      <Input type="text" placeholder="6128343120001" autoComplete="off" {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />

              {/* Permissions */}
              <FormField
                control={form.control}
                name="permissions"
                render={() => (
                  <FormItem className="flex flex-col">
                    <div className="flex items-center justify-between mb-1">
                      <FormLabel>Permissions</FormLabel>
                      {selectedPermissions.length > 0 && (
                        <span className="text-xs text-muted-foreground">
                          {selectedPermissions.length} selected
                        </span>
                      )}
                    </div>

                    {isLoadingPermissions ? (
                      <div className="flex items-center justify-center py-6 border rounded-md">
                        <ClipLoader size={20} />
                      </div>
                    ) : availablePermissions.length === 0 ? (
                      <div className="text-sm text-gray-500 py-4 border rounded-md text-center">
                        No permissions available
                      </div>
                    ) : (
                      <ScrollArea className="h-[280px] border rounded-md p-3">
                        <div className="space-y-5">
                          {PERMISSION_GROUPS.map((group) => (
                            <PermissionGroup
                              key={group.label}
                              group={group}
                              availablePermissions={availablePermissions}
                              selectedPermissions={selectedPermissions}
                              onToggle={handlePermissionToggle}
                              onToggleAll={handleToggleAll}
                            />
                          ))}
                        </div>
                      </ScrollArea>
                    )}
                    <FormMessage />
                  </FormItem>
                )}
              />

              <Button type="submit" disabled={isLoading}>
                {isLoading ? (
                  <span className="mx-[20px]">
                    <ClipLoader color="white" size={20} />
                  </span>
                ) : (
                  <span>Submit</span>
                )}
              </Button>
            </form>
          </Form>
        </div>
      </ScrollArea>
    </div>
  );
};

export default InviteTradingPartner;